import { ErrorResponse, ErrorTimeout } from 'oidc-client-ts'

import { env } from '@/config/env'

export function authOidcTimestamp(): string {
  return new Date().toISOString()
}

/** Silent by default. Set `VITE_AUTH_OIDC_DEBUG=true` to reactivate logs in any mode, including preview. */
export function isAuthOidcDebugEnabled(): boolean {
  return env.AUTH_OIDC_DEBUG === 'true'
}

export function authOidcDebugLog(
  event: string,
  detail?: Record<string, unknown>
): void {
  if (isAuthOidcDebugEnabled()) {
    const PREFIX = '[CommunoAuth]'
    const t = authOidcTimestamp()
    if (detail && Object.keys(detail).length > 0) {
      console.info(`${PREFIX} ${t} ${event}`, detail)
    } else {
      console.info(`${PREFIX} ${t} ${event}`)
    }
  }
}

export function authOidcSerializeError(e: unknown): Record<string, unknown> {
  if (e instanceof ErrorTimeout) {
    return { kind: 'oidc_ErrorTimeout', message: e.message, name: e.name }
  }
  if (e instanceof ErrorResponse) {
    return {
      kind: 'oidc_ErrorResponse',
      error: e.error,
      error_description: e.error_description,
      error_uri: e.error_uri,
      session_state: e.session_state,
    }
  }
  if (e instanceof Error) {
    return { kind: 'Error', message: e.message, name: e.name }
  }
  return { kind: 'unknown', string: String(e) }
}

export function authOidcSilentRenewErrorMayBenefitFromIframeFallback(
  e: unknown
): boolean {
  if (e instanceof ErrorTimeout) {
    return true
  }
  if (e instanceof ErrorResponse) {
    const code = e.error ?? ''
    const desc = String(e.error_description ?? '').toLowerCase()
    return (
      code === 'invalid_grant' ||
      code === 'login_required' ||
      code === 'interaction_required' ||
      desc.includes('not active')
    )
  }
  return false
}

export function authOidcUserSnapshotMeta(
  user: {
    expired?: boolean
    expires_at?: number
  } | null
): Record<string, unknown> {
  if (!user) {
    return { userPresent: false }
  }
  const nowSec = Math.floor(Date.now() / 1000)
  const exp = user.expires_at
  return {
    userPresent: true,
    expired: user.expired ?? null,
    expires_at: exp ?? null,
    nowSec,
    expiresInSec: typeof exp === 'number' ? exp - nowSec : null,
  }
}
